import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-6e.svg'

const data = {
  question:
    'Which statement best describes the effects of vaping/using e-cigarettes on your brain?',
  inputType: 'radio',
  options: [
    {
      label:
        'Unlike regular cigarettes, e-cigarettes do not contain nicotine and are not addictive.',
    },
    {
      label:
        'The effects on the brain from using e-cigarettes/vaping are always temporary.',
    },
    {
      label:
        'E-cigarette use can cause changes to the brain, affecting decision-making and memory.',
    },
    {
      label:
        'E-cigarettes are easy to quit because they are only mentally addictive.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[2].label,
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'Vaping or using e-cigarettes can cause structural changes to your brain. Those changes can cause addiction and affect decision-making and memory.',
  },
  error: {
    title: 'Not quite.',
    body:
      'Vaping or using e-cigarettes can cause structural changes to your brain. Those changes can cause addiction and affect decision-making and memory. You will learn more about this in the module.',
  },
}

export default {
  title: 'Question 5',
  path: '/prepare/question-5',
  content: (
    <Fragment>
      <Intro title="Question 5" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question5.js